import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ThemeToggle from '../components/ThemeToggle';
import { useTheme } from '../context/ThemeContext';

const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  text-align: center;
`;

const ErrorCode = styled.h1`
  font-size: 120px;
  margin: 0;
  color: var(--primary-color);
  opacity: 0.5;
`;

const ErrorTitle = styled.h2`
  font-size: 32px;
  margin: 10px 0 20px;
  color: var(--text-primary);
`;

const ErrorMessage = styled.p`
  font-size: 18px;
  margin-bottom: 30px;
  color: var(--text-secondary);
  max-width: 500px;
`;

const HomeLink = styled(Link)`
  display: inline-block;
  background-color: var(--primary-color);
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 16px;
  transition: background-color 0.3s;

  &:hover {
    background-color: #303f9f;
  }
`;

const NotFound: React.FC = () => {
  const { theme } = useTheme();
  return (
    <NotFoundContainer>
      <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
        <ThemeToggle />
      </div>
      <ErrorCode>404</ErrorCode>
      <ErrorTitle>Page Not Found</ErrorTitle>
      <ErrorMessage>
        The page you are looking for might have been removed, had its name changed,
        or is temporarily unavailable.
      </ErrorMessage>
      <HomeLink to="/">Go to Homepage</HomeLink>
    </NotFoundContainer>
  );
};

export default NotFound;
